import "@/App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import ConditionDetail from "./pages/ConditionDetail";
import Areas from "./pages/Areas";
import County from "./pages/County";
import Resources from "./pages/Resources";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

// Router-agnostic app shell (used by BrowserRouter on the client and StaticRouter for prerendering).
export default function AppShell() {
  const { pathname } = useLocation();
  return (
        <div className="App min-h-screen" data-testid="app-root">
          <ScrollToTop />
          <Navbar />
          <main key={pathname} className="page-enter min-h-[70vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/therapists" element={<Navigate to="/team" replace />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/conditions/:slug" element={<ConditionDetail />} />
              <Route path="/areas-we-serve" element={<Areas />} />
              <Route path="/areas-we-serve/:slug" element={<County />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
  );
}
